import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import chatbotImage from '../robot.jpg';
import { trainModel, deleteIntent, deleteEntity } from '../routing/routes';

const Entrenamiento = ({ intents, entities, setNotification, refreshData, permisos }) => {
	const [training, trainingChanged] = useState(false);
	const [mode, setMode] = useState(true);
	function train() {
		if (training) return;
		trainingChanged(true);
		trainModel()
			.then((json) => {
				refreshData();
				if (json.n > 0) {
					setNotification('mChatbot entrenado correctamente, reiniciando chatbots...');
				} else {
					if (json.sent) {
						setNotification('wNo se pudo entrenar al chatbot en estos momentos, intenta mas tarde...');
					} else {
						setNotification('wEl chatbot ya ha sido entrenado con todos los ejemplos previamente disponibles...');
					}
				}
				trainingChanged(false);
			})
			.catch((err) => {
				setNotification('eHubo un error entrenando al chatbot');
				console.error('Error:', err);
				trainingChanged(false);
			});
	}
	return (
		<div>
			{permisos.entrenar && (
				<div style={{ textAlign: 'center' }}>
					<img src={chatbotImage} alt='entrenar chatbots' className='train-chatbots' onClick={() => train()} />
				</div>
			)}
			<div className='tabMenu' style={{ marginTop: 20, marginBottom: 15 }}>
				<div
					onClick={() => setMode(true)}
					style={{ paddingTop: 5, paddingBottom: 5 }}
					className={mode ? 'tabChild tabChild-selected' : 'tabChild'}>
					Intents
				</div>
				<div
					onClick={() => setMode(false)}
					style={{ paddingTop: 5, paddingBottom: 5 }}
					className={!mode ? 'tabChild tabChild-selected' : 'tabChild'}>
					Entities
				</div>
			</div>
			<h1 style={{ textAlign: 'center', marginTop: 0 }}>{mode ? 'Intents' : 'Entities'}</h1>
			<TrainingBody
				data={mode ? intents : entities}
				mode={mode}
				permisos={permisos}
				refreshData={refreshData}
				setNotification={setNotification}
			/>
		</div>
	);
};

const TrainingBody = ({ data, mode, permisos, setNotification, refreshData }) => {
	const history = useHistory();
	if (mode) {
		return (
			<>
				{permisos.crearIntenciones && (
					<Link to='/intents/new'>
						<button className='floatingButton'>+</button>
					</Link>
				)}
				{data.map((intent) => (
					<Intent
						key={intent._id}
						intent={intent}
						history={history}
						permisos={permisos}
						refreshData={refreshData}
						setNotification={setNotification}
					/>
				))}
			</>
		);
	} else {
		return (
			<>
				{permisos.crearEntidades && (
					<Link to='/entities/new'>
						<button className='floatingButton'>+</button>
					</Link>
				)}
				{data.map((entity) => (
					<Entity
						key={entity._id}
						entity={entity}
						history={history}
						permisos={permisos}
						refreshData={refreshData}
						setNotification={setNotification}
					/>
				))}
			</>
		);
	}
};

const Intent = ({ intent, history, permisos, setNotification, refreshData }) => {
	return (
		<div style={{ position: 'relative' }}>
			<div className='intent' onClick={() => permisos.modificarIntenciones && history.push('/intents/edit/' + intent._id)}>
				<h2 style={{ margin: 0, marginLeft: 30 }}>
					{intent.intent}
					{intent.examples.length === 0 && (
						<b style={{ color: 'red', fontSize: 'medium' }}>Es necesario dar de alta frases de entrenamiento</b>
					)}
				</h2>
				<ul>
					{intent.examples
						.slice(0, 4)
						.map((example, index) =>
							index !== 3 ? <li key={index}>{example.phrase}</li> : <li key={index}>...</li>
						)}
				</ul>
			</div>
			{permisos.eliminarIntenciones && (
				<button
					onClick={() => {
						deleteIntent(intent._id)
							.then(() => {
								refreshData();
								setNotification('mIntencion borrada correctamente');
							})
							.catch(() => {
								setNotification('eNo se ha podido borrar la intencion');
							});
					}}
					className='floatingButtonDelete'>
					X
				</button>
			)}
		</div>
	);
};

const Entity = ({ entity, history, permisos, setNotification, refreshData }) => {
	return (
		<div style={{ position: 'relative' }}>
			<div className='entity' onClick={() => permisos.modificarEntidades && history.push('/entities/edit/' + entity._id)}>
				<h2 style={{ margin: 0, marginLeft: 30 }}>
					{entity.entity}
					{entity.subentities.length === 0 && (
						<b style={{ color: 'red', fontSize: 'medium' }}>Es necesario dar de alta frases de entrenamiento</b>
					)}
				</h2>
				<ul>
					{entity.subentities
						.slice(0, 4)
						.map((example, index) =>
							index !== 3 ? <li key={index}>{example.subentity}</li> : <li key={index}>...</li>
						)}
				</ul>
			</div>
			{permisos.eliminarEntidades && (
				<button
					onClick={() => {
						deleteEntity(entity._id)
							.then(() => {
								refreshData();
								setNotification('mEntidad borrada correctamente');
							})
							.catch(() => {
								setNotification('eNo se ha podido borrar la entidad');
							});
					}}
					className='floatingButtonDelete'>
					X
				</button>
			)}
		</div>
	);
};

export default Entrenamiento;
